import { render } from "./PassengerItem.vue?vue&type=template&id=47167e16"
import script from "./PassengerItem.vue?vue&type=script&lang=js"
export * from "./PassengerItem.vue?vue&type=script&lang=js"

import "./PassengerItem.vue?vue&type=style&index=0&id=47167e16&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__